export const filterIdPrefix = {
  panels: 'all_panels',
  device: 'all_devices',
}
